import { render, staticRenderFns } from "./login3.vue?vue&type=template&id=6aaae4be&scoped=true&"
import script from "./login3.vue?vue&type=script&lang=js&"
export * from "./login3.vue?vue&type=script&lang=js&"
import style0 from "./login3.vue?vue&type=style&index=0&id=6aaae4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaae4be",
  null
  
)

export default component.exports